export default __webpack_public_path__ + "static/media/hopin-icon.724367cf.svg";